import { useNavigate } from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────────
// MarketingNav — shared top navigation for all marketing/public pages
// (landing page, coming soon, future marketing pages — NOT the main app)
// ─────────────────────────────────────────────────────────────────────────────
export default function MarketingNav() {
  const navigate = useNavigate();

  return (
    <>
      {/* Responsive overrides shared by all marketing pages */}
      <style>{`
        @media (max-width: 900px) {
          .mn-links { display: none !important; }
          .mn-signin { display: none !important; }
        }
      `}</style>

      <nav style={{
        width: "100%", boxSizing: "border-box",
        padding: "20px 40px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        maxWidth: 1400, margin: "0 auto",
        position: "relative", zIndex: 10,
      }}>
        {/* Logo — clickable, returns to landing */}
        <button
          onClick={() => navigate("/")}
          style={{
            display: "flex", alignItems: "center", gap: 10,
            background: "none", border: "none", padding: 0,
            cursor: "pointer", fontFamily: "inherit",
          }}
          title="LifeDesk home"
        >
          <img
            src="/images/logo.png"
            alt="LifeDesk logo"
            style={{ width: 38, height: 38, borderRadius: 9, objectFit: "contain", display: "block" }}
            onError={(e) => {
              e.target.outerHTML = `
                <div style="
                  width: 38px; height: 38px; border-radius: 9px;
                  border: 1.5px dashed #93C5FD; background: #EFF6FF;
                  display: flex; align-items: center; justify-content: center;
                  color: #3B82F6; font-size: 10px; font-weight: 700; letter-spacing: 0.3px;
                ">LOGO</div>
              `;
            }}
          />
          <span style={{ fontWeight: 800, fontSize: 22, color: "#0F172A", letterSpacing: -0.5 }}>LifeDesk</span>
        </button>

        {/* Center nav links (hidden on mobile) */}
        <div className="mn-links" style={{ display: "flex", gap: 36, alignItems: "center" }}>
          <button onClick={() => navigate("/coming-soon")} style={navLinkBtn}>Features</button>
          <button onClick={() => navigate("/coming-soon")} style={navLinkBtn}>How it works</button>
          <button onClick={() => navigate("/coming-soon")} style={navLinkBtn}>Pricing</button>
        </div>

        {/* Right actions */}
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <button
            onClick={() => navigate("/app")}
            className="mn-signin"
            style={{
              background: "none", border: "none",
              color: "#475569", fontWeight: 600, fontSize: 14,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Sign in
          </button>
          <button
            onClick={() => navigate("/app")}
            style={{
              background: "#2563EB", color: "#fff", border: "none",
              borderRadius: 9, padding: "10px 20px",
              fontWeight: 700, fontSize: 14, cursor: "pointer",
              fontFamily: "inherit", boxShadow: "0 2px 8px rgba(37,99,235,.25)",
            }}
          >
            Get started
          </button>
        </div>
      </nav>
    </>
  );
}

const navLinkBtn = {
  background: "none", border: "none", padding: 0,
  color: "#475569", fontSize: 14, fontWeight: 600,
  cursor: "pointer", fontFamily: "inherit",
};
